import { Container, Sprite, Text, TextStyle, Texture } from 'pixi.js';
import app from '..';
import { ItemIDs, prizeWheelRewardItems } from '../Config/Items';
import { MapList, NODES_PER_MAP } from '../Config/Levels';
import { Actions } from '../State/Actions/Actions';
import { getLevelIndex, IStuckArgs, StuckReasons } from '../State/reducers/level';
import {
    hasAlreadyBeenRequestedGiftTo,
    hasAlreadyBeenSentCoinsTo,
    hasAlreadyBeenSentGiftTo,
} from '../State/reducers/social';
import { Views } from '../State/reducers/view';
import { Collection } from '../Tiles/TileSet';
import DateUtils from '../Utils/DateUtils';
import { GameKeys } from '../Utils/GameKeys';
import { getRandom } from '../Utils/Utils';
import Core from './Core';
import getLogger, { ILogger, setLogLevel } from './Logger';
import BoardUtils from '../Game/BoardUtils';

const logger: ILogger = getLogger('[DEBUG]:');

export default class Debug {
    // TODO add support to choose
    public static initDebugCommands() {
        window.reset = () => {
            const completed = Core.sdk.data.saveData('completedLevels', null);
            completed.catch(err => {
                logger.debug('error resetting levels: ' + err);
            });
            const stars = Core.sdk.data.saveData('totalStars', 0);
            stars.catch(err => {
                logger.debug('error resetting stars: ' + err);
            });
            const level = Core.sdk.data.saveData('levelId', 'machu-1');
            level.catch(err => {
                logger.debug('error resetting levelId: ' + err);
            });
            const coin = Core.sdk.data.saveData('coin', 0);
            coin.catch(err => {
                logger.debug('error resetting coin: ' + err);
            });
            const heart = Core.sdk.data.saveData('heart', 5);
            heart.catch(err => {
                logger.debug('error resetting heart: ' + err);
            });
            const sound = Core.sdk.data.saveData('isSoundOn', null);
            sound.catch(err => {
                logger.debug('error resetting sound: ' + err);
            });
            const music = Core.sdk.data.saveData('isMusicOn', null);
            music.catch(err => {
                logger.debug('error resetting music: ' + err);
            });
            const unlocked = Core.sdk.data.saveData('unlockedMaps', null);
            unlocked.catch(err => {
                logger.debug('error resetting unlocked: ' + err);
            });
            const visited = Core.sdk.data.saveData('visitedMaps', null);
            visited.catch(err => {
                logger.debug('error resetting visited: ' + err);
            });
            const messages = Core.sdk.data.saveData('messageIds', null);
            messages.catch(err => {
                logger.debug('error resetting recieved messages: ' + err);
            });
            const boosters = Core.sdk.data.saveData('boosters', null);
            boosters.catch(err => {
                logger.debug('error resetting boosters: ' + err);
            });
            const tracked = Core.sdk.data.saveData('tracked', null);
            tracked.catch(err => {
                logger.debug('error resetting tracked list: ' + err);
            });
            const pendingInvites = Core.sdk.data.saveData('pendingInvites', null);
            pendingInvites.catch(err => {
                logger.debug('error resetting pendingInvites: ' + err);
            });
            const confirmedInvitations = Core.sdk.data.saveData('confirmedInvites', null);
            confirmedInvitations.catch(err => {
                logger.debug('error resetting confirmedInvitations: ' + err);
            });
            const receivedInvites = Core.sdk.data.saveData('receivedInvites', null);
            receivedInvites.catch(err => {
                logger.debug('error resetting receivedInvites: ' + err);
            });
            const missions = Core.sdk.data.saveData('missions', null);
            missions.catch(err => {
                logger.debug('error resetting missions: ' + err);
            });

            const refresher = Core.sdk.data.saveData('missionRefreshTimer', null);
            refresher.catch(err => {
                logger.debug('error resetting missionRefreshTimer: ' + err);
            });

            const missionsCompleted = Core.sdk.data.saveData('missionsCompleted', null);
            missionsCompleted.catch(err => {
                logger.debug('error resetting missionsCompleted: ' + err);
            });

            const missionsShown = Core.sdk.data.saveData('missionsShown', null);
            missionsShown.catch(err => {
                logger.debug('error resetting missionsShown: ' + err);
            });

            const lastLevel = Core.sdk.data.saveData('lastLevelIndex', null);
            lastLevel.catch(err => {
                logger.debug('error resetting lastLevelIndex: ' + err);
            });

            const activeCollection = Core.sdk.data.saveData('activeCollection', null);
            activeCollection.catch(err => {
                logger.debug('error resetting activeCollection: ' + err);
            });

            const collectablesProgress = Core.sdk.data.saveData('collectablesProgress', null);
            collectablesProgress.catch(err => {
                logger.debug('error resetting collectablesProgress: ' + err);
            });

            const shortcutOptIn = Core.sdk.data.saveData('optInShortcutRewardDate', null);
            shortcutOptIn.catch(err => {
                logger.debug('error resetting optInShortcutRewardDate: ' + err);
            });

            const botOptIn = Core.sdk.data.saveData('optInRewardDate', null);
            botOptIn.catch(err => {
                logger.debug('error resetting optInRewardDate: ' + err);
            });

            const trackQueue = Core.sdk.data.saveData(Core.delta.queueSaveKey, null);
            trackQueue.catch(err => {
                logger.debug('error resetting trackQueue: ' + err);
            });
            const mapChests = Core.sdk.data.saveData('unlockedChests', null);
            mapChests.catch(err => {
                logger.debug('error resetting unlockedChests: ' + err);
            });

            const sentCoins = Core.sdk.data.saveData('sentCoins', null);
            sentCoins.catch(err => {
                logger.debug('error resetting sentCoins: ' + err);
            });

            const resetPurchases = Core.sdk.data.saveData('purchases', null);
            resetPurchases.catch(err => {
                logger.debug('error resetting shopHasBeenOpened: ' + err);
            });

            const resetShopOpened = Core.sdk.data.saveData('shopHasBeenOpened', null);
            resetShopOpened.catch(err => {
                logger.debug('error resetting shopHasBeenOpened: ' + err);
            });
        };

        // TODO find a way to make this inaccessible on live game
        // just for QA testing purposes

        window.MOJIDebugQA1 = () => {
            if (Core.store) {
                Core.store.dispatch(Actions.updateCoins(1000));
            }
        };

        window.MOJIDebugQA2 = () => {
            if (Core.container && Core.store.getState().StateView === Views.GAME) {
                const all = Core.store.getState().StateBoard.boardTiles.slice(0);
                const tiles = all.filter(a => a.tileType.suit !== 'special');
                const specials = all.filter(a => a.tileType.suit === 'special');
                tiles.forEach(t => {
                    Core.store.dispatch(
                        Actions.removeMatch([[t.boardId], [BoardUtils.formatId(t.tileType)]])
                    );
                });

                specials.forEach(s => {
                    Core.store.dispatch(Actions.findObject([s.boardId]));
                });

                Core.store.dispatch(Actions.countObject(Core.store.getState().StateLevel.found));
                Core.store.dispatch(Actions.registerMove([]));

                // use just this to test levelComplete action
                // Core.store.dispatch(Actions.levelComplete());
            }
        };

        window.MOJIDebugQA3 = () => {
            if (Core.container) {
                Core.store.dispatch(Actions.updateCoins(-Core.store.getState().StateCurrency.coin));
                // Core.container.handleRemoveCoins();
            }
        };

        window.MOJIDebugQA4 = () => {
            if (Core.store) {
                Core.store.dispatch(Actions.updateHearts(1));
            }
        };

        window.MOJIDebugQA5 = (collection: Collection, progress: number) => {
            if (Core.store) {
                Core.store.dispatch(Actions.setCollectablesProgress([collection, progress]));
            }
        };

        window.MOJIDebugQA6 = (state: string) => {
            if (Core.store) {
                Core.store.getState().StatePlayer.unlockedChests.forEach((element, index) => {
                    Core.store.dispatch(Actions.changeChestState([index, state]));
                });
                logger.debug(['Set all chests to ', state]);
            } else {
                logger.debug('No store');
            }
        };

        window.MOJIDebugQA7 = (item: ItemIDs) => {
            if (Core.store) {
                Core.store.dispatch(Actions.storeBooster([item]));
            }
        };

        window.MOJIDebugQA8 = async (day: number, month: number, year: number) => {
            const date = new Date(year, month - 1, day);
            const time = date.getTime();
            await Core.sdk.data.saveData('lastLogin', time);
        };

        window.MOJIDebugQA9 = async () => {
            Core.store.dispatch(Actions.shopGift(0));
        };

        window.sendRequestDebug = async () => {
            if (Core.store) {
                const style = new TextStyle({
                    fill: 'white',
                    fontFamily: '"Lucida Console", Monaco, monospace',
                    fontSize: 14,
                });
                const friends = await Core.sdk.messages.getFriends();
                friends.forEach((friend: any, index: number) => {
                    const container = new Container();
                    container.y = index * 50;
                    app.stage.addChild(container);
                    const bg = new Sprite(Texture.WHITE);
                    bg.tint = 0;
                    bg.width = 400;
                    bg.height = 40;
                    bg.interactive = true;
                    container.addChild(bg);
                    const txtFriend = new Text(`${friend.name} - ${friend.userId}`, style);
                    container.addChild(txtFriend);
                    const txtSendGift = new Text('---', style);
                    txtSendGift.y = 20;
                    container.addChild(txtSendGift);
                    const txtRequestGift = new Text('---', style);
                    txtRequestGift.position.set(150, 20);
                    container.addChild(txtRequestGift);
                    const txtSendCoins = new Text('---', style);
                    txtSendCoins.position.set(300, 20);
                    container.addChild(txtSendCoins);

                    // Utils ---------------------------------------------
                    const oneMinute = DateUtils.minutesToMilliseconds(1);
                    const cooldown = (txt: Text, ts: number, label: string) => {
                        const intervalId = setInterval(() => {
                            const timeRemaining = DateUtils.timeRemainingTo(oneMinute + ts);
                            if (timeRemaining > 0) {
                                txt.text = DateUtils.format(timeRemaining, 'D hh:mm:ss');
                            } else {
                                txt.text = label;
                                txt.interactive = true;
                                txt.buttonMode = true;
                                clearInterval(intervalId);
                            }
                        }, 1000);
                    };

                    // Send Gift ---------------------------------------------
                    txtSendGift.on('pointerdown', async () => {
                        const result = await Core.sdk.messages.sendGift(friend.userId);
                        if (result) {
                            txtSendGift.interactive = false;
                            txtSendGift.buttonMode = false;
                            Core.store.dispatch(Actions.sendGift(friend.userId));
                            const gift = hasAlreadyBeenSentGiftTo(
                                Core.store.getState().StateSocial,
                                friend.userId
                            );
                            if (gift) {
                                cooldown(txtSendGift, gift.ts, 'Send');
                            }
                        }
                    });

                    const sentGift = hasAlreadyBeenSentGiftTo(
                        Core.store.getState().StateSocial,
                        friend.userId
                    );
                    if (sentGift && DateUtils.timeRemainingTo(oneMinute + sentGift.ts) > 0) {
                        // 48 hours
                        cooldown(txtSendGift, sentGift.ts, 'Send');
                    } else {
                        txtSendGift.text = 'Send';
                        txtSendGift.interactive = true;
                        txtSendGift.buttonMode = true;
                    }

                    // Request Gift ---------------------------------------------
                    txtRequestGift.on('pointerdown', async () => {
                        const result = await Core.sdk.messages.requestGift(friend.userId);
                        if (result) {
                            txtRequestGift.interactive = false;
                            txtRequestGift.buttonMode = false;
                            Core.store.dispatch(Actions.requestGift(friend.userId));
                            // tslint:disable-next-line:no-shadowed-variable
                            const requestedGift = hasAlreadyBeenRequestedGiftTo(
                                Core.store.getState().StateSocial,
                                friend.userId
                            );
                            if (requestedGift) {
                                cooldown(txtRequestGift, requestedGift.ts, 'Request');
                            }
                        }
                    });

                    const requestedGift = hasAlreadyBeenRequestedGiftTo(
                        Core.store.getState().StateSocial,
                        friend.userId
                    );
                    if (
                        requestedGift &&
                        DateUtils.timeRemainingTo(oneMinute + requestedGift.ts) > 0
                    ) {
                        // 48 hours
                        cooldown(txtRequestGift, requestedGift.ts, 'Request');
                    } else {
                        txtRequestGift.text = 'Request';
                        txtRequestGift.interactive = true;
                        txtRequestGift.buttonMode = true;
                    }

                    // Send Coins ---------------------------------------------
                    txtSendCoins.on('pointerdown', async () => {
                        const coins = getRandom(15, 25);
                        const result = await Core.sdk.messages.sendCoins(friend.userId, coins);
                        if (result) {
                            txtSendCoins.interactive = false;
                            txtSendCoins.buttonMode = false;
                            Core.store.dispatch(Actions.sendCoins(friend.userId));
                            // tslint:disable-next-line:no-shadowed-variable
                            const sentCoins = hasAlreadyBeenSentCoinsTo(
                                Core.store.getState().StateSocial,
                                friend.userId
                            );
                            if (sentCoins) {
                                Core.store.dispatch(Actions.receiveGift(['coin', coins])); // TODO: trigger coins animation
                                cooldown(txtSendCoins, sentCoins.ts, 'Coins');
                            }
                        }
                    });

                    const sentCoins = hasAlreadyBeenSentCoinsTo(
                        Core.store.getState().StateSocial,
                        friend.userId
                    );
                    if (sentCoins && DateUtils.timeRemainingTo(oneMinute + sentCoins.ts) > 0) {
                        // 8 hours
                        cooldown(txtSendCoins, sentCoins.ts, 'Coins');
                    } else {
                        txtSendCoins.text = 'Coins';
                        txtSendCoins.interactive = true;
                        txtSendCoins.buttonMode = true;
                    }
                });
            }
        };

        window.MOJIDebugPassToLevel = (index: number) => {
            const last =
                Core.store.getState().StatePlayer.lastLevelIndex ||
                getLevelIndex(Object.keys(Core.store.getState().StatePlayer.mapLevels).pop());
            if (last <= index) {
                for (let i = last; i <= index; i++) {
                    const mapId = MapList[Math.floor(i / NODES_PER_MAP)];
                    if (!mapId) {
                        break;
                    }
                    const mapIndex = i - Math.floor(i / NODES_PER_MAP) * NODES_PER_MAP;
                    const neededId = mapId + '-' + mapIndex.toString(10);
                    if (i % NODES_PER_MAP === 0) {
                        Core.store.dispatch(Actions.unlockMap(mapId));
                    }
                    if (!Core.store.getState().StatePlayer.mapLevels[neededId]) {
                        Core.store.dispatch(Actions.unlockMapLevel(neededId));
                        Core.store.dispatch(Actions.updateMapData({ id: neededId, stars: 3 }));
                        Core.store.dispatch(Actions.changeView(Views.MAP));
                    }
                }
            }
        };

        window.MOJIDebugMissionRefresh = () => {
            Core.store.dispatch(Actions.missionRefreshComplete());
        };

        window.MOJIDebugMissionComplete = (index: number) => {
            const m = Core.store.getState().StateMissions.missions[index - 1];
            if (m) {
                Core.store.dispatch(Actions.missionComplete(m.uid));
            }
        };

        window.MOJIDebugRefreshPrizeWheel = () => {
            Core.store.dispatch(Actions.setPriceWheelCooldown(1));
        };

        window.MOJIDebugFailLevel = ({
            reason = StuckReasons.MATCHES,
            stuck = true,
        }: IStuckArgs) => {
            if (
                Core.store.getState().StateView === Views.GAME &&
                Core.store.getState().StateBoard.ready
            ) {
                Core.store.dispatch(Actions.setLevelStuck({ reason, stuck }));
            }
        };

        window.MOJIDebugForceJackpot = () => {
            prizeWheelRewardItems.forEach((x, index) => {
                x.chance = index === 2 ? 100 : 0;
            });
        };

        window.MOJIDebugAddTime = (time: number) => {
            Core.store.dispatch(Actions.addWinTime(time));
        };

        window.MOJISetLogLevel = (int: number) => {
            setLogLevel(int);
        };
    }

    constructor(useKeys: boolean = false) {
        if (useKeys) {
            GameKeys.init();
            // this.initDebugKeys();
        }
    }
}
